import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';

import { AuthService } from '../auth/auth.service';
import { ShowError } from '../layout/state/layout.actions';

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private store: Store<AppState>, private authService: AuthService) {}
  handleError(error: HttpErrorResponse) {
    console.log(error);
    if (error.status === 500) {
      console.log('500 error: ', error);
      if (!error.url.includes('logs') && !error.url.includes('httpstat')) {
        console.log('[Error Interceptor] Call error ', error);
      }
    } else {
      if (error && error.url && !error.url.includes('logs') && !error.url.includes('httpstat')) {
        console.log('[Error Interceptor] Call error ', error);
      }
      if (error.status === 401) {
        this.authService.logout();
        const message = error.error && error.error.code === 'Unauthorized' ? error.error.data : 'Unauthorized user';
        this.store.dispatch(ShowError({ message }));
      } else {
        this.store.dispatch(ShowError({ message: error.message }));
      }
    }
    return throwError(error);
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError(this.handleError.bind(this)));
  }
}
